// Libs
import React, { Component } from 'react'
import { connect } from 'react-redux'

// CSS
import './styles.scss'

// Actions
import { changeSelectedFeature } from './actions'

//SVG
import chatIcon from '../../assets/feature/paperPlane.png'
import historyIcon from '../../assets/feature/cloud.png'
import contactIcon from '../../assets/feature/message.png'

//Components
import FeatureChat from './components/FeatureChat'
import FeatureHistory from './components/FeatureHistory'
import FeatureContact from './components/FeatureContact'

class Feature extends Component {

  UNSAFE_componentWillMount() {
    const { featureList, changeSelectedFeature } = this.props

    changeSelectedFeature(featureList)
  }

  getComponent = (icon = false) => {
    const { selectedFeature } = this.props
    let component

    switch (selectedFeature.type) {
      case 'chat':
        if (icon)
          return chatIcon
        return <FeatureChat />
      case 'history':
        if (icon)
          return historyIcon
        return <FeatureHistory />
      case 'contact':
        if (icon)
          return contactIcon
        return <FeatureContact />
      default:
        break
    }
  }

  render() {

    const { selectedFeature } = this.props

    return (
      <div className="feature">
        {this.getComponent()}
        <div className="feature__footer">
          <div className="feature__footer--header">
            <div className="feature__footer--label">
              <span>{selectedFeature.title}</span>
              <span>{selectedFeature.label}</span>
            </div>
            <span className="feature__footer-image--wrapper"><img src={this.getComponent(true)} alt="featureIcon" /></span>
          </div>
          <span className="feature__footer--description">
            {selectedFeature.description}
          </span>
        </div>
      </div>
    )
  }
}

Feature = connect(
  (state, ownProps) => ({
    featureList: state.feature.featureList,
    selectedFeature: state.feature.selectedFeature
  }), { changeSelectedFeature })(Feature)

export default Feature
